<main role="main">
    <div class="container">
        <h1>Lista de Escolas</h1>
        <div id="div-lista-escolas">

        </div>
    </div>
</main>